"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireWildcard(require("react"));
var _spacing = require("../../../constants/spacing");
var _useTheme = require("../../../theme/utils/useTheme");
var _MenuParentContext = require("../context/MenuParentContext");
var _menuTheme = require("../styled/menuTheme");
var _MenuItemBase = require("./MenuItemBase");
// It's necessary to explicitly specify top/bottom padding when multiline, because the
// before/after content needs to be aligned with the first line of text, whereas the text needs to be center aligned.
// Without the padding, the before/after content would be too high. 6px is just the right amount of padding to get a
// target height of xxLarge (36px) with exactly 2 lines of text. Anything with more than 2 lines will scale and still
// have enough padding to not look squished.
const MenuItemDefaultStyle = (0, _styled.default)(_MenuItemBase.MenuItemBase)`
    justify-content: space-between;
    ${_ref => {
  let {
    isMultiLine
  } = _ref;
  return isMultiLine ? `
                align-items: flex-start;
                min-height: ${_spacing.sizes.xxLarge}px;
                padding-top: 6px;
                padding-bottom: 6px;
                ` : "";
}}
`;
const StyledContentBefore = (0, _styled.default)("div")(_ref2 => {
  let {
    isMultiLine
  } = _ref2;
  return {
    marginRight: _spacing.sizes.xSmall,
    marginTop: isMultiLine ? -2 : undefined,
    lineHeight: 0
  };
});
const StyledContentAfter = (0, _styled.default)("div")`
    margin-left: 8px;
    align-self: center;
    line-height: 0;
`;
const ShiftyDiv = (0, _styled.default)("div")`
    flex-grow: 1;
    line-height: 18px;
    align-self: center;
    padding-left: ${_ref3 => {
  let {
    indent,
    themeMode
  } = _ref3;
  return indent ? _menuTheme.menuTheme.hasContentLeftPadding(themeMode) : "0";
}};
`;

// eslint-disable-next-line @typescript-eslint/no-empty-interface

/**
 * Simple wrapper around a baseMenuItem to allow simple menu items w/ no icons, checkmarks, etc.
 */
const MenuItem = /*#__PURE__*/(0, _react.forwardRef)((_ref4, ref) => {
  let {
    children,
    contentBefore,
    contentAfter,
    contentBelow,
    isDisabled,
    ...rest
  } = _ref4;
  const {
    hasContentBefore
  } = (0, _MenuParentContext.useMenuParentContext)();
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const isMultiline = !!contentBelow;
  return /*#__PURE__*/_react.default.createElement(MenuItemDefaultStyle, (0, _extends2.default)({}, rest, {
    isDisabled: isDisabled || false,
    ref: ref,
    isMultiLine: isMultiline
  }), contentBefore && /*#__PURE__*/_react.default.createElement(StyledContentBefore, {
    isMultiLine: isMultiline
  }, contentBefore) || null, /*#__PURE__*/_react.default.createElement(ShiftyDiv, {
    indent: hasContentBefore && !contentBefore,
    themeMode: themeMode
  }, children, contentBelow && /*#__PURE__*/_react.default.createElement("div", null, contentBelow) || null), contentAfter && /*#__PURE__*/_react.default.createElement(StyledContentAfter, null, contentAfter) || null);
});
exports.MenuItem = MenuItem;
MenuItem.displayName = "MenuItem";
//# sourceMappingURL=MenuItem.js.map